/* Presentation only; no native menu, product form or variant handlers replaced. */
(() => {
  if (customElements.get('ots-product-hero')) return;
  customElements.define('ots-product-hero', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      this.observer = new ResizeObserver(() => this.measure());
      this.attachHeader = () => {
        this.observer.disconnect();
        this.header = document.querySelector('.section-header');
        if (this.header) this.observer.observe(this.header);
        this.measure();
      };
      this.attachHeader();
      this.querySelector('.ots-story-choose')?.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const anchor = document.getElementById('OTSProductPurchase');
        const productInfo = anchor?.closest('product-info') || document.querySelector('#MainContent product-info');
        const options = productInfo?.querySelector('variant-selects');
        const price = productInfo?.querySelector('[id^="price-"]');
        const target = (price?.getClientRects().length ? price : null) || options || anchor || productInfo?.querySelector('product-form');
        if (!target) return;
        event.preventDefault();
        // Show the current variant price above the options, clear of the native sticky header.
        const top = Math.max(0, scrollY + target.getBoundingClientRect().top - (this.header?.offsetHeight || 0) - 24);
        options?.querySelector('input:checked, select')?.focus({ preventScroll: true });
        window.scrollTo({ top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, { signal: this.events.signal });
      // Retain the explicit preview template after Dawn updates the variant URL.
      // Native variant requests, form values and sharing behavior stay intact.
      const initial = new URL(location.href);
      if (initial.searchParams.get('view') === 'ots-immersive' && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, () => {
          const current = new URL(location.href);
          if (current.pathname === initial.pathname) {
            current.searchParams.set('view', 'ots-immersive');
            history.replaceState(history.state, '', current);
          }
        });
      }
      document.addEventListener('shopify:section:load', this.attachHeader, { signal: this.events.signal });
      document.addEventListener('shopify:section:reorder', this.attachHeader, { signal: this.events.signal });
    }
    measure() {
      const active = this.dataset.integrated === 'true' && document.querySelector('#MainContent > .shopify-section')?.contains(this);
      this.style.setProperty('--ots-story-offset', `${active ? this.header?.offsetHeight || 0 : 0}px`);
    }
    disconnectedCallback() { this.events?.abort(); this.observer?.disconnect(); this.unsubscribeVariant?.(); }
  });
})();
